export const updateSystemMutation = () => {
    return `mutation UpdateSystem(
        $systemId: Int!,
        $name: String,
        $abbreviation: String,
        $logoUrl: String,
        $type: String
    ) {
        updateSystem(
            systemId: $systemId,
            name: $name,
            abbreviation: $abbreviation,
            logoUrl: $logoUrl,
            type: $type
        ) {
            system {
                id
                name
                abbreviation
                type
                logoUrl
            }
        }
    }`
}
